import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $NextButtonModal = styled(Col)`
  margin-left: auto;
`;

export const $AddressRow = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${spacing('px')};
`;

export const $ModalRowWithMargin = styled(Row)`
  margin-bottom: ${spacing('lg')};
`;

interface SuggestionAddressProps {
  $isChecked: boolean;
}

export const $SuggestionTitle = styled.div<SuggestionAddressProps>`
  ${fontStyle('sm')};
  color: ${({ theme, $isChecked }) =>
    $isChecked ? theme.colors.primary : theme.colors.paragraphTextColor};
  font-weight: ${fontWeight('medium')};
  text-transform: uppercase;
  display: block;
  margin-bottom: ${spacing(1.5)};
`;

export const $SuggestionContent = styled.div<SuggestionAddressProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  span {
    color: ${({ theme, $isChecked }) =>
      $isChecked ? theme.colors.black : theme.colors.paragraphTextColor};
  }
`;

export const $ModalContent = styled.div`
  h3 {
    font-weight: ${fontWeight('bold')};
  }
`;
